import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

import { toPx } from '../../../utils/toPx'

export const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexGrow: 1,
  height: toPx(60),
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  padding: `0 ${toPx(sharedStyles.Spacings.MEDIUM)}`,
  backgroundColor: sharedStyles.Colors.BUTTON_MESSENGER,
  borderRadius: toPx(sharedStyles.BorderRadius.SMALL),
  borderWidth: toPx(sharedStyles.BorderWidth.MEDIUM),
  borderColor: sharedStyles.Colors.BUTTON_MESSENGER,
  borderStyle: 'solid',
}

export const wrapperHoverStyle: React.CSSProperties = {
  ...wrapperStyle,
  borderColor: sharedStyles.Colors.PRIMARY,
}
